import {
    Alignments
} from '@utils/KontentTypes';
import { mapFirstKenticoImage } from '@utils/Helpers';

export const mapToPageHeader = (data: any) => {
    const pageTitle = data.generalPageContentTitle.value;
    const position = 
        data.generalPageContentTitlePosition === undefined || 
        data.generalPageContentTitlePosition.value === undefined || 
        data.generalPageContentTitlePosition.value.length === 0
            ? 'center'
            : data.generalPageContentTitlePosition.value[0].codename;

    const isResponsiveBannerImage = 
        data.generalPageContentResponsiveHeaderImage &&
        data.generalPageContentResponsiveHeaderImage.linkedItems.length > 0;

    return {
        title: pageTitle,
        image: {
            mobile: mapFirstKenticoImage(
                isResponsiveBannerImage
                    ? data.generalPageContentResponsiveHeaderImage.linkedItems[0].elements.mobile.value
                    : data.generalPageContentHeaderImage.value
            ),
            tablet: mapFirstKenticoImage(
                isResponsiveBannerImage
                    ? data.generalPageContentResponsiveHeaderImage.linkedItems[0].elements.tablet.value
                    : data.generalPageContentHeaderImage.value
            ),
            desktop: mapFirstKenticoImage(
                isResponsiveBannerImage
                    ? data.generalPageContentResponsiveHeaderImage.linkedItems[0].elements.desktop.value
                    : data.generalPageContentHeaderImage.value
            ),
        },
        textAlign: position as Alignments
    };
};
